import * as types from './actionTypes';
import {apiRequest, apiPost, apiPut, apiDelete, apiRequestAnonymous} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import { push } from '../utils/navigation';
import { BASE_URL } from '../constants';
import initialState from "../reducers/initialState";
import { getErrorMessage, requestHasError } from '../utils/lib';

export function loadRunsSuccess(runs){
  return {type: types.LOAD_RUNS_SUCCESS, runs};
}

export function runLocationCheckInSuccess(checkIn){
  return {type: types.RUN_LOCATION_CHECKIN_SUCCESS, checkIn};
}

export function runLocationPickupTankSuccess(update){
  return {type: types.RUN_LOCATION_TANK_PICKUP_SUCCESS, update};
}

export function runLocationAddNoteSuccess(update){
  return {type: types.RUN_LOCATION_ADDNOTE_SUCCESS, update};
}

export function loadDriverRunsSuccess(driverRuns){
  return {type: types.LOAD_DRIVER_RUNS_SUCCESS, driverRuns};
}

export function loadRunSuccess(run){
  return {type: types.LOAD_RUN_SUCCESS, run};
}

export function addLocationToNewRunSuccess(location){
  return {type: types.NEW_RUN_LOCATION_ADD, location};
}

export function removeLocationToNewRunSuccess(location){
  return {type: types.NEW_RUN_LOCATION_REMOVE, location};
}

export function setUrgentLocationToNewRunSuccess(location){
  return {type: types.NEW_RUN_LOCATION_SETURGENT, location};
}

export function newRunEditSuccess(run){
  return {type: types.NEW_RUN_EDIT, run};
}

export function newRunCreatedSuccess(run){
  return {type: types.NEW_RUN_CREATED, run};
}

export function newRunSaving(){
  return {type: types.NEW_RUN_SAVING};
}

export function updateRunsFilter(filter){
  return {type: types.LOAD_RUNS_FILTERCHANGED, filter};
}


export function loadRuns(showNotifications = true, isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes = []) {
  return function (dispatch) {
    if(showNotifications){
      dispatch(loadRunsSuccess({ loaded: false, items: [], isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes}));
    }
    return apiRequest(`/api/runs?isComplete=${isComplete}&dateFrom=${dateFrom}&dateTo=${dateTo}&selectedDriverId=${selectedDriverId}${selectedTypes.map(x => `&customerTypes=${x}`).join('')}`)
      .then(x => {
        dispatch(loadRunsSuccess({ loaded: false, items: [], isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes}));
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching runs, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadRunsSuccess({ loaded: true, items: [], isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes}));
        } else {
          dispatch(loadRunsSuccess({ loaded: true, items: Array.from(x.data), isComplete, dateFrom, dateTo, selectedDriverId, selectedTypes}));
        }
      });
  };
}

// projected pickups
export function loadProjectedRunFields({runId}) {
  return function (dispatch) {
    return apiRequest(`/api/pickups/${runId}/projected`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching pickup projections, error: ${x.error ? x.error : x.data.Message}`);
        } 
        return x;
      });
  };
}

//export function setRunOrder(runId, runOrder)
export function setRunOrder(items, callBackFn)
{
  const runOrders = items.map(item => {
    return { runId: item.id, runOrder: item.runOrder };
  });  

  return function (dispatch) {
    return apiPost(`/api/runs/setRunOrder`, runOrders)
    .then(x => {
      console.log(x);
      if (x.error || x.data.Message) {
        toastr.error(`Error while setting Run Order, error: ${x.error ? x.error : x.data.Message}`);        
      } 
      else
      {
        toastr.success(`Runs Order Updated`);
        callBackFn();
      } 
    });
  };
}

function getActionItems(){
  let actions = localStorage.getItem("pendingActions");
  return actions ? JSON.parse(actions) : [];
}
function setActionItems(actions){
  localStorage.setItem("pendingActions", JSON.stringify(actions));
}

function addActionToLocalStorage(action, key){
  let actionId = JSON.stringify(key);
  let actions = removeActionFromLocalStorage(actionId);
  actions.push({id: actionId, action});
  setActionItems(actions);
  return actionId;
}

export let Processing = false;

export function processPendingActions() {
  return function (dispatch) {
    if(Processing){
      return;
    }
    Processing = true;
    let actions = getActionItems();
    for (let i = 0; i < actions.length; i++) {
      console.log(`Retrying ${actions[i].action}`);
      eval(`dispatch(${actions[i].action});`);
      removeActionFromLocalStorage(actions[i].id);
    }
    Processing = false;
  };
}

function removeActionFromLocalStorage(actionId){
  let actions = getActionItems();
  let index = actions.findIndex((x) => x.id == actionId);
  if(index >= 0){
    actions.splice(index, 1);
    setActionItems(actions);
  }
  return actions;
}

export function runLocationCheckIn(runId, pickupId, status, cancelReason, numberOfTins, location = null) {
  return function (dispatch, getState) {
    location = location ? JSON.parse(location) : getState().location;
    let statusUpdate = {runId, pickupId, status, cancelReason, numberOfTins,
      latitude: location.coords ? location.coords.latitude : null,
      longitude: location.coords ? location.coords.longitude: null
    };
    toastr.info(`Saving...`);

    return apiPost('/api/runs/pickup', statusUpdate)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving: ${x.error ? x.error : x.data.Message}`);
          if (numberOfTins) {
            addActionToLocalStorage(`runLocationCheckIn(${runId}, ${pickupId}, '${status}', null, ${numberOfTins}, '${ (location && location.coords) ? JSON.stringify({
                coords: {
                  latitude: location.coords.latitude,
                  longitude: location.coords.longitude
                }
              }) : null}')`,
              {pickupTins: {runId, pickupId}}
            );
          }
        } else {
          toastr.success(numberOfTins == null ? 'Saved location' : 'Saved location tin pickup');
          if(x.data.isComplete){
            dispatch(loadDriverRuns(true));
            dispatch(push(`${BASE_URL}/runs/driver/`));
          } else {
            dispatch(runLocationCheckInSuccess({...statusUpdate, runId, response: x.data}));
          }
        }
      });
  };
}

/*export function runLocationPickupTank(runId, pickupId, tankId, estimatedLitres, location = null) {
  return function (dispatch, getState) {    
    location = location ? JSON.parse(location) : getState().location;    
    let statusUpdate = {
      runId, pickupId, tankId, estimatedLitres,
      latitude: location.coords ? location.coords.latitude : null,
      longitude: location.coords ? location.coords.longitude: null
    };

    let actionId = addActionToLocalStorage(`runLocationPickupTank(${runId}, ${pickupId}, ${tankId}, ${estimatedLitres}, 
    '${ (location && location.coords) ? JSON.stringify({coords: {latitude: location.coords.latitude, longitude: location.coords.longitude}}) : null}')`,
      {pickupTank: {runId, pickupId, tankId}}
    );

    toastr.info(`Saving...`);
    return apiPost('/api/runs/pickupTank', statusUpdate)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving: ${x.error ? x.error : x.data.Message}`);
        } else {
          removeActionFromLocalStorage(actionId);
          toastr.success('Saved location pickup');
          dispatch(runLocationPickupTankSuccess({...statusUpdate, runId, response: x.data}));
        }
      });
  };
}*/


export function runLocationCompletePickup(pickup, isCancel, location = null, isAction = false) {
  return function (dispatch, getState) {
    location = location ? JSON.parse(location) : getState().location;
    let update = {
      pickup: (typeof pickup === 'string' || pickup instanceof String) ? JSON.parse(pickup) : pickup,
      isCancel,
      latitude: (location && location.coords) ? location.coords.latitude : null,
      longitude: (location && location.coords) ? location.coords.longitude : null
    };

      toastr.info(`Saving...`);
      return apiPost('/api/runs/completePickup', update)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while saving: ${x.error ? x.error : x.data.Message}`);

            addActionToLocalStorage(`runLocationCompletePickup(${JSON.stringify(pickup)}, ${isCancel}, 
              '${ (location && location.coords) ? JSON.stringify({
                coords: {
                  latitude: location.coords.latitude,
                  longitude: location.coords.longitude
                }
              }) : null}', true)`,
              {completePickup: {pickup, isCancel}});

          } else {
            //removeActionFromLocalStorage(actionId);
            toastr.success('Saved pickup');
            dispatch(runLocationPickupTankSuccess({...update, runId: update.pickup.runId, response: x.data}));
          }
        });
    //} else {
      //fetch(`${FullBaseUrl()}/index.html`);
      //dispatch(processPendingActions());
    //}
  };
}

export function runLocationCompleteAssignTank(pickup, tank, location = null) {
  return function (dispatch, getState) {
    location = location ? JSON.parse(location) : getState().location;
    let update = {
      pickup: (typeof pickup === 'string' || pickup instanceof String) ? JSON.parse(pickup) : pickup,
      tank: (typeof pickup === 'string' || pickup instanceof String) ? JSON.parse(tank) : tank,      
      latitude: (location && location.coords) ? location.coords.latitude : null,
      longitude: (location && location.coords) ? location.coords.longitude : null
    };
    
    
    toastr.info(`Saving...`);
    return apiPost('/api/runs/completeAssignTank', update)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while saving: ${x.error ? x.error : x.data.Message}`);

            addActionToLocalStorage(`runLocationCompleteAssignTank(${JSON.stringify(pickup)}, ${JSON.stringify(tank)}, 
              '${ (location && location.coords) ? JSON.stringify({
              coords: {
                latitude: location.coords.latitude,
                longitude: location.coords.longitude
              }
            }) : null}')`);

          } else {
            //removeActionFromLocalStorage(actionId);
            toastr.success('Assigned tank');
            dispatch(runLocationPickupTankSuccess({...update, runId: update.pickup.runId, response: x.data}));
          }
        });
    //} else {
    //fetch(`${FullBaseUrl()}/index.html`);
    //dispatch(processPendingActions());
    //}
  };
}



/*export function runLocationAddNote(runId, pickupId, note, location = null) {
  return function (dispatch, getState) {
    location = location ? JSON.parse(location) : getState().location;
    let statusUpdate = {
      runId, pickupId, note,
      latitude: location.coords ? location.coords.latitude : null,
      longitude: location.coords ? location.coords.longitude: null
    };
    toastr.info(`Saving...`);

    let actionId = addActionToLocalStorage(`runLocationAddNote(${runId}, ${pickupId}, '${note}', '${ (location && location.coords) ? JSON.stringify({coords: {latitude: location.coords.latitude, longitude: location.coords.longitude}}) : null}')`,
      {addNote: {runId, pickupId}}
    );

    return apiPost('/api/runs/pickupNote', statusUpdate)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving: ${x.error ? x.error : x.data.Message}`);
        } else {
          removeActionFromLocalStorage(actionId);
          toastr.success('Saved pickup note');
          dispatch(runLocationAddNoteSuccess({...statusUpdate, runId, response: x.data}));
        }
      });
  };
}*/

export function runRequestConfirmation(runId) {
  let postData = {runId};
  return function (dispatch) {
    toastr.info(`Requesting run confirmation via sms...`);
    return apiPost(`/api/runs/${runId}/requestConfirmation`, postData)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving: ${x.error ? x.error : x.data.Message}`);
        } else {
          toastr.success(`Successfully sent: ${x.data.length} sms messages to confirm run`);
          dispatch(loadRun(runId, null, null, false, true));
        }
      });
  };
}

let driverRunsRetry = null;
export function loadDriverRuns(showNotifications = true) {
  return function (dispatch, getState) {
    let location = getState().location;
    let account = getState().account;

    if(!account || !account.user || !account.user.hasRole('Driver')){
      dispatch(loadDriverRunsSuccess({loaded: true, items: []}));
      return;
    }


    let locationArg = location.coords ? `?latitude=${location.coords.latitude}&longitude=${location.coords.longitude}` : '';

    if (showNotifications) {
      toastr.info(`Fetching driver runs...`);
    }
    if(driverRunsRetry){
      clearTimeout(driverRunsRetry);
      driverRunsRetry = null;
    }
    return apiRequest(`/api/runs/driver${locationArg}`)
      .then(x => {
        toastr.clean();
        if (x.error || x.data.Message) {
          if(x.data && x.data.status == 504 && !driverRunsRetry){
            toastr.warning('Timeout fetching driver runs, retrying in 5 secs');
            driverRunsRetry = setTimeout(() => {
              dispatch(loadDriverRuns(showNotifications));
            }, 5000);
          } else {
            toastr.error(`Error while fetching runs: ${x.error ? x.error : x.data.Message}`);
            dispatch(loadDriverRunsSuccess({loaded: true, items: []}));
          }
        } else {
          if (showNotifications) {
            toastr.success(`Fetched ${x.data.length} driver run(s)`);
          }
          dispatch(loadDriverRunsSuccess({loaded: true, items: Array.from(x.data)}));
        }
      });
  };
}

export function loadRun(runId, driverRuns, searchRuns, includeDriverLocations = false, hideSmsNoResponse=true, showNotifications=true) {
  return function (dispatch, getState) {
    let location = getState().location;
    let locationArg = location.coords ? `&latitude=${location.coords.latitude}&longitude=${location.coords.longitude}` : '';
    let hideSmsNoResponseArg = `&hideSmsNoResponse=${hideSmsNoResponse}`;
    
      return apiRequest(`/api/runs/${runId}?includeDriverLocations=${includeDriverLocations}${locationArg}${hideSmsNoResponseArg}`)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while fetching runId: ${runId} error: ${x.error ? x.error : x.data.Message}`);
            dispatch(loadRunSuccess({}));
          } else {
            if(showNotifications){
              toastr.success(`Fetched runId: ${runId}`);
            }
            dispatch(loadRunSuccess({...x.data}));
          }
        });
    };
  
}


export function saveRun(run, currentRun){
  return function (dispatch) {
    let runToSave = {
      id: run.id,
      truckId: run.truckId,
      driverId: run.driverId,
      timeStart: run.timeStart,
      pickups: run.pickups,
      allowAutoReorder: run.allowAutoReorder,
    };

    return apiPut(`/api/runs/${runToSave.id}`,runToSave)
      .then(x => {
        if (x.error || x.data.Message) {
          console.log(x);
          toastr.error(`Error while saving runId: ${run.id} error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadRunSuccess({...currentRun}));
        }
        else {
          toastr.success('Updated run');
          dispatch(loadRunSuccess({...x.data}));
        }
      });
  };
}

export function saveRunReorder(run, currentRun){
  return function (dispatch, getState) {
    let location = getState().location;

    let runToSave = {
      id: run.id,
      pickups: run.pickups,
      currentLocation: location.coords ? {
        latitude: location.coords.latitude,
        longitude: location.coords.longitude
      } : null
    };
    toastr.success('Saving run reorder');
    return apiPut(`/api/runs/reorder`,runToSave)
      .then(x => {
        if (x.error || x.data.Message) {
          console.log(x);
          toastr.error(`Error while saving runId: ${run.id} error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadRunSuccess({...currentRun}));
        }
        else {
          toastr.success('Reordered run');
          dispatch(loadRunSuccess({...x.data}));
        }
      });
  };
}

export function addLocationToNewRun(location){
  return function (dispatch) {
      dispatch(addLocationToNewRunSuccess(location));
  };
}

export function removeLocationToNewRun(location){
  return function (dispatch) {
    dispatch(removeLocationToNewRunSuccess(location));
  };
}

export function setUrgentLocationToNewRun(location){
  return function (dispatch) {
    dispatch(setUrgentLocationToNewRunSuccess(location));
  };
}

export function newRunEdit(run){
  return function (dispatch) {
    dispatch(newRunEditSuccess(run));
  };
}

export function saveNewRun(run){
  return function (dispatch) {
    dispatch(newRunSaving());
    apiPut(`/api/runs/${run.id}`, run)
      .then(x => {
        if (x.error || x.data.Message) {
          console.log(x);
          toastr.error(`An error occurred while saving new run, error: ${x.error ? x.error : x.data.Message}`);
        }
        else {
          toastr.success('Created new run');
          dispatch(loadRunSuccess({...x.data}));
          dispatch(newRunCreatedSuccess(run));
          dispatch(push(`${BASE_URL}/runs/search/${x.data.id}`));
        }
      });
  };
}


export function deleteRun(runId){
  return function (dispatch, getState) {
    if (confirm('Are you sure you want to delete this run?')) {
      let searchParams = getState().searchRuns;
      apiDelete(`/api/runs/${runId}`)
        .then(x => {
          if (x.error || x.data.Message) {
            console.log(x);
            toastr.error(`An error occurred while deleting, error: ${x.error ? x.error : x.data.Message}`);
          }
          else {
            toastr.success('Deleted run');
            dispatch(loadRunSuccess({}));
            dispatch(loadRuns(true, searchParams.isComplete, searchParams.dateFrom, searchParams.dateTo));
            dispatch(push(`${BASE_URL}/runs/search/`));
          }
        });
    }
  };
}

export function UpdateFilter(filter = {isComplete : initialState.searchRuns.isComplete, dateFrom : initialState.searchRuns.dateFrom, dateTo : initialState.searchRuns.dateTo, selectedDriverId: initialState.searchRuns.selectedDriverId, selectedTypes: initialState.searchRuns.selectedTypes}){  
  return function (dispatch) {
    dispatch(updateRunsFilter(filter));
  };
}

export function getPickupConfirmationDetails({token}) {
  return function (dispatch) {
      return apiRequestAnonymous(`/api/runs/requestconfirmation/link?id=${token}`)
          .then(x => {
            if (requestHasError({x})) {
              toastr.error(getErrorMessage({x}));
            }
             return x;
          });
  };
}

export function clientConfirmPickup({payLoad}) {
  return function (dispatch) {
      return apiRequestAnonymous(`/api/runs/confirmPickup/link`, 'POST', true, payLoad)
          .then(x => {
            if (requestHasError({x})) {
              toastr.error(getErrorMessage({x}));
            }
             return x;
          });
  };
}

export function updatePickupPhotos({payLoad}){
  return function () {
    return apiPost('/api/runs/pickup/upload-photo',payLoad)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(getErrorMessage({x}));
        }
        return x;
      });
  };
}



